import { render, staticRenderFns } from "./PolicyLoopCom.vue?vue&type=template&id=03c9d70d&"
import script from "./PolicyLoopCom.vue?vue&type=script&lang=ts&"
export * from "./PolicyLoopCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports